import { AdvancedImage } from "@cloudinary/react";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";

const CatalogThumb = ({ imageId, icon = "pi pi-image" }) => (
  <span className="admin-catalog__thumb" aria-hidden="true">
    {imageId ? (
      <AdvancedImage
        cldImg={cloudinaryInstance.image(imageId).resize(fill().width(88).height(88)).format("webp")}
        alt=""
      />
    ) : (
      <i className={icon} />
    )}
  </span>
);

export default CatalogThumb;
